'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    _extends({ viewBox: '0 0 60 40' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: '#5666AF', d: 'M60,35c0,2.75-2.25,5-5,5H5c-2.75,0-5-2.25-5-5V5c0-2.75,2.25-5,5-5h50c2.75,0,5,2.25,5,5V35z' }),
      _react2.default.createElement('path', { opacity: '0.04', fill: '#FFFFFF', enableBackground: 'new    ', d: 'M58.531,1.469C59.438,2.375,60,3.625,60,5v15v15 c0,1.375-0.562,2.625-1.469,3.531C57.624,39.438,56.375,40,55,40H30H5c-1.375,0-2.625-0.562-3.531-1.469L58.531,1.469z' }),
      _react2.default.createElement('path', { fill: '#57B1D9', d: 'M30,0' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#EA574C', d: 'M30,13.4c-1.833-2.08-4.51-3.4-7.5-3.4c-5.522,0-10,4.477-10,10c0,5.521,4.478,10,10,10 c2.99,0,5.667-1.32,7.5-3.4c-1.552-1.763-2.5-4.065-2.5-6.6S28.448,15.162,30,13.4z' }),
        _react2.default.createElement('path', { fill: '#EA574C', d: 'M30,13.4c-1.552,1.762-2.5,4.067-2.5,6.6s0.948,4.837,2.5,6.6c1.552-1.763,2.5-4.065,2.5-6.6 S31.552,15.162,30,13.4z' })
      ),
      _react2.default.createElement('path', { fill: '#E9D41E', d: 'M37.5,10c-2.99,0-5.667,1.32-7.5,3.4c-0.433,0.492-0.812,1.03-1.144,1.6h2.288 c0.364,0.625,0.647,1.299,0.871,2h-4.044c-0.203,0.643-0.35,1.309-0.419,2h4.879c0.034,0.33,0.068,0.66,0.068,1 c0,0.338-0.02,0.671-0.053,1h-4.895c0.069,0.691,0.216,1.357,0.419,2h4.056c-0.223,0.704-0.522,1.372-0.886,2h-2.285 c0.331,0.568,0.711,1.107,1.144,1.6c1.833,2.08,4.51,3.4,7.5,3.4c5.522,0,10-4.479,10-10C47.5,14.477,43.021,10,37.5,10z' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#7784B7', d: 'M55,1c2.206,0,4,1.794,4,4v30c0,2.206-1.794,4-4,4H5c-2.206,0-4-1.794-4-4V5c0-2.206,1.794-4,4-4H55 M55,0 H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h50c2.75,0,5-2.25,5-5V5C60,2.25,57.75,0,55,0L55,0z' })
      )
    )
  );
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=Icon_MasterCard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-credit-card-icons/lib/Icon_MasterCard.js
// module id = 1494
// module chunks = 0